import http from '../../http';
// import {ValidarToken} from '../../validarToken';

export const get = (id) => {
    return (dispatch, getState) => {
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        };
   
        // var parameters = JSON.stringify({ id });

        http.get('herramientas/version/obtener.php', config)
            .then(function (response) {
                // <ValidarToken codigo={response.data.codigo} mensaje={response.data.mensaje} />
                // console.log(response);
                dispatch({
                    type: "VERSION_GET", payload: {
                        data: response.data,
                    }
                });
            })
            .catch(function (error) {
                // console.log(error.response);
                let errorMessage = "";
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    //console.log(error.response.data.mensaje);                    
                    //console.log(error.response.status);
                    //console.log(error.response.headers);
                    errorMessage = error.response.data.mensaje;
                  } else if (error.request) {
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    //console.log(error.request);
                    errorMessage = "The request was made but no response was received";
                  } else {
                    // Something happened in setting up the request that triggered an Error
                    errorMessage = error.message;
                  }
    
                  dispatch({ type: 'VERSION_ERROR', payload: { error: errorMessage } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            });        
    }    
}

export const closeMessages = () => {
    return (dispatch, getState) => {
        dispatch({type: "VERSION_CLOSE_MESSAGES"});
    }
}